/* globals Raven */

/**
 * Отмена действия по умолчанию для ссылок с атрибутом href="#".
 * В нашей заготовки таковыми являются ссылки, для которых предполагается реальный href,
 * но который на вёрстке ещё не известен.
 * Если не отменить для таких ссылок действие по умолчанию,
 * то при клике страница перепрыгнет на самый верх, а в адресной строке появится #.
 *
 * NOTE: Также данный модуль отправляет сообщения в логгер, если подобные ссылки
 * найдены на продакт-сервере (там вместо # должны быть проставлены реальные адреса).
 */
itsoftApp.createModule("linksWithHash", function () {
    const module = this;

    const LinksWithHash = function () {
        this.links = document.querySelectorAll("a[href='#']");
        this.isLocal = itsoftApp.isLocal;

        this.init();
    };

    /**
     * Простой обрабочик, который отменяет действие по умолчанию
     *
     * @param  {object} e Event
     */
    LinksWithHash.prototype.linksWithHashHandler = function (e) {
        e.preventDefault();
        DEBUG && console.log("[module linksWithHash] default action prevented for link");
    };

    // Привязка функций к событиям
    LinksWithHash.prototype.addListener = function () {
        const LINKSWITHHASH = this;
        for (var i = 0, len = LINKSWITHHASH.links.length, link; i < len; i++) {
            link = LINKSWITHHASH.links[i];
            link.addEventListener("click", LINKSWITHHASH.linksWithHashHandler.bind(LINKSWITHHASH), false);
        }
    };

    // Если на боевом сервере найдены ссылки с атрибутом href="#",
    // то отправляем в логгер сообщение об ошибке,
    // так как там уже должны быть настоящие ссылки вместо заглушек.
    LinksWithHash.prototype.checkRaven = function () {
        if (typeof Raven !== "undefined" && !this.isLocal) {
            const extra = {};

            // Формируем объект, в котором перечислены все найденные ссылки,
            // причём с указанием их html-кода
            // (для того, чтобы можно было определить, какие именно ссылки найдены, точно ли это ошибка или нет)
            Array.prototype.forEach.call(this.links, function (link, index) {
                const html = link.outerHTML;
                extra["link" + (index + 1)] = html;
            });

            Raven.captureMessage("[module linksWithHash] links with href='#' found", {
                level: "warning", // one of 'info', 'warning', or 'error'
                extra: extra,
            });
        }
    };
    LinksWithHash.prototype.init = function () {
        if (!this.links.length) {
            return false;
        }
        DEBUG &&
            console.log(
                "%c[module linksWithHash] " + this.links.length + " links with href='#' found. is it ok for this page?? maybe you need to replace '#' with normal link? check it.",
                "color: orange"
            );
        this.addListener();
        this.checkRaven();
    };

    new LinksWithHash();
    module.callback = LinksWithHash;
});
